export const paymentData = [
  {
    id: 2,
    title: "Venmo",
    link: "https://venmo.com/code?user_id=2739533162479616678&created=1649297678.683289&printed=1",
    text: "Send payments to: @NitroCo",
    footer: "Venmo",
    imgSrc: "assets/QR_Venmo.jpg",
    imgAlt: "Venmo",
  },
  {
    id: 6,
    title: "CashApp",
    link: "https://cash.app/$Nitromc",
    text: "Send payments to: $Nitromc",
    footer: "CashApp",
    imgSrc: "assets/QR_CashApp.jpg",
    imgAlt: "CashApp",
  },
  {
    id: 4,
    title: "Zelle",
    link: "https://enroll.zellepay.com/qr-codes?data=eyJuYW1lIjoiTklUUk8gTU9WSU5HIENPTVBBTlkgTExDIiwiYWN0aW9uIjoicGF5bWVudCIsInRva2VuIjoibml0cm9tb3Zpbmdjb21wYW55QGdtYWlsLmNvbSJ9",
    text: "Send payments to: nitromovingcompany@gmail.com",
    footer: "Zelle",
    imgSrc: "assets/QR_Zelle.jpg",
    imgAlt: "Zelle",
  },
];